import React, { memo } from 'react';

import { ICONS } from '../../../icons';
import ProjectNameHeader from '../project-name-header/ProjectNameHeader';

const ScoutHeader = () => {
  return <ProjectNameHeader icon={ICONS.Scout} defaultName='SCout' selector={(state) => state.scout.projectName} />;
};

export default memo(ScoutHeader);
